import React from 'react';
import Category from './Category';

/**
 * MainMenu
 */
class MainMenu extends React.Component {

  render() {
    return (
      <div id="main_menu">
        <div id="modal_menu_close">
          <i className="fa fa-times fa-2x" />
        </div>
        <Category />
      </div>
    );
  }
}

export default MainMenu;
